import React from "react";
import { Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { ICareerData } from "../../types/api/careerApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { ICareer, ISubCareer } from "../../types/features/multiLanguageSlice";
const CareerSection: React.FC<{ career_data: Array<ICareerData> }> = ({ career_data }) => {
    const {t} = useTranslation()
    const career_json = t('career.careers', { returnObjects: true })  as ISubCareer[];

    return (
        <div>
            <div>
                <section className='career-section'>
                    <div className="container">
                        <div className="career-list">
                            <ul>
                                {career_json && career_json.length > 0 ?
                                    career_json.map((career: ISubCareer, index: number) => (
                                        <li key={"Career_" + index}>
                                            <Row className="career-item p-0">
                                                <Col md={5} className="p-0">
                                                    <div className="post-info">
                                                        <h4 className="title">{career.role_title}</h4>
                                                        <p className="text">{career.role}</p>
                                                    </div>
                                                </Col>
                                                <Col md={4} className="p-0">
                                                    <div className="location-info post-info">
                                                        <h4 className="title">{t('career.location')}</h4>
                                                        <p className="text">{career.location}</p>
                                                    </div>
                                                </Col>
                                                <Col md={3} className="p-0">
                                                    <div className="type-info">
                                                        <div className=" post-info">
                                                            <h4 className="title"> {t('career.employment_type')} </h4>
                                                            <p className="text">{career.employment_type}</p>
                                                        </div><span className="bi bi-arrow-right"></span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </li>
                                    ))
                                    : <NoData message="Oops, No Career Data Found!!" />
                                }
                            </ul>
                            <p className="career-text">
                            {t('career.career_description')}
                                <Link to="mailto:info@ebreazehotel.com">{t('footer.email')}</Link>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default CareerSection;